import { IInternalAccount } from '../api/internal/internalApi.types';
import { IInternalAccountState } from '../features/transfer/transferSlice.types';

export const getHolderFullNames = (holders: any[] | null | undefined) => {
  if (!holders || holders.length === 0) {
    return [];
  }
  return holders
    .map((holder) => holder?.name?.fullName)
    .filter((fullName) => fullName !== null);
};

export const formatHolderFullNames = (holderFullNames?: string[]): string => {
  if (!holderFullNames || holderFullNames.length === 0) {
    return '';
  }

  if (holderFullNames.length === 1) {
    return holderFullNames[0];
  }

  const allButLast = holderFullNames.slice(0, -1).join(', ');
  const last = holderFullNames[holderFullNames.length - 1];

  return `${allButLast}, and ${last}`;
};

export const isSelectedAccountIneligible = (
  selectedAccount: IInternalAccountState | null,
  internalAccountsList: IInternalAccount[] | null | undefined,
): boolean => {
  if (!selectedAccount || !internalAccountsList) {
    return false;
  }

  const matchingAccount = internalAccountsList.find(
    (account) =>
      account.agreementNumber === selectedAccount.accountNumber &&
      account.agreementTypeValue.enumerationName === selectedAccount.selectedAccountType,
  );

  return matchingAccount ? !matchingAccount.isTransferEligible : false;
};
